"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsButtonVisible = void 0;
var _environment = require("@ori/environment");
var _presentationUtils = require("@ori/presentation-utils");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
var _webMessengerContext = require("../contexts/webMessengerContext");
/** Turns on chatbot ANNA */
const UseNewBotChat = '986DF7FE-88E1-4742-B77F-43DC8B3D2F76';

/**
 * Checks if chat-bot is used and if chat is opened.
 * If chat-bot is used WebMessenger button is visible right after chat-bot opens WebMessenger.
 * If chat-bot is not used WebMessenger button is always visible.
 */
const useIsButtonVisible = () => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    isChatOpened
  } = (0, _webMessengerContext.useWebMessenger)();
  const [isButtonVisible, setIsButtonVisible] = (0, _react.useState)(false);
  const {
    data: {
      isEnabled
    } = {
      isEnabled: true
    }
  } = (0, _staticApiClientReact.useGetTenantFeatureToggle)(tenant, UseNewBotChat, {
    swr: (0, _presentationUtils.getRetryErrorSwrOptions)()
  });
  (0, _react.useEffect)(() => {
    if (isChatOpened || !isEnabled) {
      setIsButtonVisible(true);
    }
  }, [isChatOpened, isEnabled]);
  return {
    isButtonVisible
  };
};
exports.useIsButtonVisible = useIsButtonVisible;
